import React, { memo } from 'react';
import { Stack, TableRow, Typography } from '@mui/material';
import MyTableCell from '../../../../../components/material-ui/adaptive/MyTableCell';
import CusCheckbox from '../../../../../components/material-ui/CusCheckbox';

const AllGameRow = memo(
  ({ game, indx, onGameClick, selectGameId, checked, setSelectIdList, gameId, providersHash }) => {
    const providerName = providersHash[game.provider]?.customName || game.provider;

    return (
      <TableRow selected={gameId == selectGameId} onClick={() => onGameClick(game)}>
        <MyTableCell sx={{ p: 0, border: 0 }}>
          <Stack px={2} direction={'row'} alignItems="center">
            <CusCheckbox
              checkBoxSx={{ paddingLeft: 0 }}
              checked={checked}
              onChange={() =>
                setSelectIdList((prev) =>
                  prev.includes(indx) ? prev.filter((el) => el != indx) : [...prev, indx]
                )
              }
            />
            <Typography fontSize={13}>
              {game.name}{' '}
              <Typography fontSize={12} color="textDisabled" component={'span'}>
                ( {providerName} {game.type} )
              </Typography>
            </Typography>
          </Stack>
        </MyTableCell>
      </TableRow>
    );
  },
  (prevProps, nextProps) =>
    prevProps.checked === nextProps.checked &&
    prevProps.selectGameId === nextProps.selectGameId &&
    prevProps.indx === nextProps.indx &&
    prevProps.game === nextProps.game
);

export default AllGameRow;
